// This file creates placeholder images for development
// In a real implementation, you would replace these with actual image imports

// Import mentor images
import mentor1 from './mentor1.png';
import mentor2 from './mentor2.png';
import mentor3 from './mentor3.png';
import mainMentor from './main-mentor.png';
import studentlearning from './studentlearning.png';
import starSvg from './star.svg';
import starOutlineSvg from './star-outline.svg';

// Placeholder creator function
const createPlaceholder = (width, height, text, bgColor = '#0077b6', textColor = '#fff') => {
  return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}' viewBox='0 0 ${width} ${height}'%3E%3Crect width='${width}' height='${height}' fill='${bgColor}'/%3E%3Ctext x='50%' y='50%' font-family='Arial' font-size='20' text-anchor='middle' fill='${textColor}' dominant-baseline='middle'%3E${text}%3C/text%3E%3C/svg%3E`;
};

// Create circular image with background
const createCircularPlaceholder = (size, text, bgColor = '#f8a65a', textColor = '#fff') => {
  return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${size}' height='${size}' viewBox='0 0 ${size} ${size}'%3E%3Ccircle cx='${size/2}' cy='${size/2}' r='${size/2}' fill='${bgColor}'/%3E%3Ctext x='50%' y='50%' font-family='Arial' font-size='20' text-anchor='middle' fill='${textColor}' dominant-baseline='middle'%3E${text}%3C/text%3E%3C/svg%3E`;
};

// Create star icon
const createStarIcon = () => {
  return `data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.1375 4.42111C10.9475 2.67223 13.0525 2.67223 13.8625 4.42111L15.3126 7.51978C15.6426 8.22332 16.3064 8.70594 17.0764 8.80333L20.4847 9.25933C22.3919 9.51839 23.1343 11.8991 21.7247 13.2397L19.2154 15.6181C18.6427 16.1633 18.3901 16.9526 18.5351 17.7258L19.1006 21.1155C19.4214 23.0125 17.4274 24.4842 15.7366 23.5639L12.7013 21.9325C12.0024 21.5559 11.1741 21.5559 10.4752 21.9325L7.43993 23.5639C5.74913 24.4842 3.75514 23.0125 4.07589 21.1155L4.64142 17.7258C4.78639 16.9526 4.53377 16.1633 3.96105 15.6181L1.45176 13.2397C0.0421647 11.8991 0.784515 9.51839 2.69174 9.25933L6.10007 8.80333C6.87005 8.70594 7.53378 8.22332 7.86385 7.51978L9.31391 4.42111C9.31391 4.42111 10.1375 4.42111 10.1375 4.42111Z' fill='rgba(247, 147, 30, 0.3)' stroke='rgba(247, 147, 30, 0.6)' stroke-width='1.5'/%3E%3C/svg%3E`;
};

// Logo
export const skillraizLogo = createPlaceholder(180, 60, 'SkillRaiz Logo', 'transparent', '#ffffff');

// Hero section
export const heroImage = createCircularPlaceholder(450, 'Student with\nOrange Notebook', '#FFAC42', '#000000');
export const sparkIcon = createStarIcon();
export const starDecoration = starSvg;
export const starOutlineDecoration = starOutlineSvg;

// About section
export const verifiedIcon = createPlaceholder(80, 80, '✓', '#14b8a6', '#ffffff');
export const mentorRaghav = mainMentor;
export const mentorDanis = mentor1;
export const mentorRevanth = mentor2;
export const mentorSanjay = mentor3;
export const starIcon = createStarIcon();
// Course features
export const awsCoreImg = createPlaceholder(200, 200, 'AWS Core', '#dbeafe', '#2563eb');
export const cicdImg = createPlaceholder(200, 200, 'CI/CD', '#dbeafe', '#2563eb');
export const dockerImg = createPlaceholder(200, 200, 'Docker & K8s', '#dbeafe', '#2563eb');
export const infraImg = createPlaceholder(200, 200, 'Infrastructure', '#dbeafe', '#2563eb');

// CTA section
export const studentLearning = studentlearning;

export default {
  skillraizLogo,
  heroImage,
  sparkIcon,
  starDecoration,
  starOutlineDecoration,
  verifiedIcon,
  mentorRaghav,
  mentorDanis,
  mentorRevanth,
  mentorSanjay,
  awsCoreImg,
  cicdImg,
  dockerImg,
  infraImg,
  studentLearning
}; 